export default "__VITE_ASSET__4EWke9T4eqQcsnhGx5FGww__"